/*
 * Vey's redesign — Featured tabs.
 * Toggles pre-rendered product grids. No network requests: every tab's
 * products are already in the DOM, so switching is instant and the ERP /
 * product-card markup is untouched.
 *
 * The script tag is emitted once per section instance (three on the
 * homepage), so everything is guarded against re-execution.
 */
if (!customElements.get('custom-featured-tabs')) {

class CustomFeaturedTabs extends HTMLElement {
  connectedCallback() {
    const sectionId = this.dataset.sectionId;
    // Scope tabs + panels to this section only.
    this.tabs = Array.from(
      document.querySelectorAll('[id^="tab-' + sectionId + '-"]')
    );
    this.panels = Array.from(
      this.querySelectorAll('[id^="panel-' + sectionId + '-"]')
    );

    // "View all" button that follows whichever tab is open (no fixed link set).
    const section = this.closest('.container') || document;
    const viewAll = section.querySelector('.js-tabs-view-all[data-follows-tab]');
    this.viewAll = viewAll;

    if (!this.tabs.length) return;

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.select(tab));
      tab.addEventListener('keydown', (e) => this.onKeydown(e));
    });

    const current = this.tabs.find((t) => t.getAttribute('aria-selected') === 'true');
    if (current) this.syncViewAll(current);
  }

  syncViewAll(tab) {
    if (!this.viewAll) return;
    const url = tab.dataset.collectionUrl;
    if (url) this.viewAll.setAttribute('href', url);
  }

  select(tab) {
    const targetId = tab.getAttribute('aria-controls');
    this.syncViewAll(tab);

    this.tabs.forEach((t) => {
      const selected = t === tab;
      t.setAttribute('aria-selected', selected ? 'true' : 'false');
      if (selected) {
        t.removeAttribute('tabindex');
      } else {
        t.setAttribute('tabindex', '-1');
      }
    });

    this.panels.forEach((panel) => {
      if (panel.id === targetId) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
      }
    });
  }

  onKeydown(e) {
    const idx = this.tabs.indexOf(e.target);
    if (idx === -1) return;

    let next = null;
    if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
      next = this.tabs[(idx + 1) % this.tabs.length];
    } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
      next = this.tabs[(idx - 1 + this.tabs.length) % this.tabs.length];
    } else if (e.key === 'Home') {
      next = this.tabs[0];
    } else if (e.key === 'End') {
      next = this.tabs[this.tabs.length - 1];
    }

    if (next) {
      e.preventDefault();
      this.select(next);
      next.focus();
    }
  }
}

customElements.define('custom-featured-tabs', CustomFeaturedTabs);

}
